
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";

const PsdToSketch = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/PSDToSketch"
        ogImage="/images/psd2sketch-og-image.jpg"
      />

      <MagicianSection
        title={t("page/PSDToSketch:title")}
        subtitle={t("page/PSDToSketch:subtitle")}
        magicianLogoFile="sketch"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConversionSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.supportsAllNativeElements", {
              format: "Photoshop",
            }),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "PHOTOSHOP",
            image: "/images/photoshop-preview.jpg",
            title: "Photoshop Demo Preview",
          },
          to: {
            iconType: "SKETCH",
            image: "/images/sketch-preview.jpg",
            title: "Sketch Demo Preview",
          },
        }}
      />
      <VideoSection
        title={t("page/PSDToSketch:section/videoSection.title")}
        subtitle={t("page/PSDToSketch:section/videoSection.subtitle")}
        media={{
          type: "PHOTO",
          title: "Upload demo",
          src: "/images/psd-to-sketch-preview.jpg",
        }}
        hasBackground
      />

      <ApiTeaserSection
        title={t("page/PSDToSketch:section/apiTeaser.title")}
        image={{
          src: "/svgs/illustration.svg",
          alt: "Magician with shield",
        }}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/PSDToSketch:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />
      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.psdToSketchPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PsdToSketch;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/psd-to-sketch',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  